import request from "superagent";
import * as actionTypes from "Consts/index";

export const toggle = (show) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SEARCH__LOADING,
      payload: true,
    });
    dispatch({
      type: actionTypes.SEARCH_FIELD__TOGGLE,
      payload: {
        show: !show,
      },
    });
    dispatch({
      type: actionTypes.SEARCH__LOADING,
      payload: false,
    });
  };
};

export const set = (searchUrl, searchText) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SEARCH_FIELD__SETVALUES,
      payload: {
        url: searchUrl,
        text: searchText,
      },
    });
  };
};
